import Modal from "/WebInterface/new-ui/modules/modal.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import store from "/WebInterface/new-ui/store/index.js";
import SearchTemplate, { searchPollingTemplate } from "./template.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { searchResultClearTemplate } from "/WebInterface/new-ui/assets/js/app/templates/filter-section.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";

export const initSearch = (args) => {
  const cssId = "search-modal-styles";
  if (!document.getElementById(cssId)) {
    const head = document.getElementsByTagName("head")[0];
    const link = document.createElement("link");
    link.id = cssId;
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = "/WebInterface/new-ui/assets/styles/app/search.css";
    link.media = "all";
    head.appendChild(link);
  }

  const handleSearch = async () => {
    const formData = utils.serializeInputs(searchDialog.root, false, true);
    const c2f = utils.cookie.get("currentAuth");
    let pollingRequest;
    let continuePolling = true;

    const isDate1Checked = _$(searchDialog.root).find("#modifiedSearch1").el().checked;
    const isDate2Checked = _$(searchDialog.root).find("#dateSearch2").el().checked;
    const isSize1Checked = _$(searchDialog.root).find("#sizeSearch1").el().checked;
    const isSize2Checked = _$(searchDialog.root).find("#sizeSearch2").el().checked;

    const dialog = new Modal({
      parent: _$("#modal_search-form .modal-card").el(),
      showHeader: false,
      hasFooter: false,
      body: searchPollingTemplate({}),
      extraClasses: ["poll-search-status-modal"],
    });

    _$("#abortSearchAction").on("click", () => {
      continuePolling = false;
      searchRequest.abort();
      pollingRequest?.abort();
      dialog?.hide(true);
    });

    const pollSearchStatus = async () => {
      pollingRequest = ajax
        .call({
          data: {
            command: "getSearchStatus",
            c2f,
          },
        })
        .then((resp) => {
          if (!continuePolling) {
            return;
          }

          const xml = new DOMParser().parseFromString(resp, "text/xml");
          const response = utils.xmlToJson(xml);
          const result = response?.commandResult?.response;

          const info = result?.split("/");
          const min = info[0] || 0;
          const max = info[1] || 1;

          const progress = _$(searchDialog.root).find(
            ".poll-search-status-progress"
          );
          progress.attr("value", min);
          progress.attr("max", max);

          setTimeout(() => {
            pollSearchStatus();
          }, 1000);
        })
        .catch((error) => {
          console.log("Polling hiba:", error);
        });
    };

    pollSearchStatus();

    const startDate = formData.date1_value;
    const endDate = formData.date2_value;

    const finalDate1Value = (isDate1Checked && startDate)
      ? utils.formatPickerDateForApi(startDate)
      : "";

    const finalDate2Value = (isDate2Checked && endDate)
      ? utils.formatPickerDateForApi(endDate)
      : "";

    const payload = {
      command: "search",
      c2f,
      ...formData,
      path: args.curPath,
      date1: isDate1Checked ? "true" : "",
      date1_action: isDate1Checked ? "before" : "",
      date1_value: finalDate1Value,
      date1_value_display: startDate || "",
      date2: isDate2Checked ? "true" : "",
      date2_action: isDate2Checked ? "after" : "",
      date2_value: finalDate2Value,
      date2_value_display: endDate || "",
      size1: isSize1Checked ? "true" : "",
      size1_action: isSize1Checked ? "bigger than" : "",
      size1_value: isSize1Checked ? formData.size1_value : "",
      size2: isSize2Checked ? "true" : "",
      size2_action: isSize2Checked ? "smaller than" : "",
      size2_value: isSize2Checked ? formData.size2_value : "",
    };

    const searchRequest = ajax
      .call({
        data: payload,
        timeout: 10000000,
      })
      .then((response) => {
        if (!continuePolling) {
          return;
        }

        const { listing, privs } = response;

        if (listing) {
          const manipulatedList = listing.map((item) => {
            const id = utils.getUId();
            return {
              ...item,
              privs: item.privs || privs,
              preview: parseInt(item.preview),
              mediaInfo: utils.isMedia(item.name),
              id: `${id}`,
              treeIds: `${id}`,
              paddingLeft: 12,
              ariaExpanded: false,
              isChecked: false,
              canPreventExpand: true,
            };
          });

          _$("#searchResultNotification").html(
            searchResultClearTemplate({
              clearText: t("clear"),
              showingSearchResultText: t("showingSearchResult"),
            })
          );

          _$("#search-result-clear-button").on("click", () => {
            _$("#searchResultNotification").html("");
            store.dispatch("refreshListing");
          });

          store.dispatch("setSearchFilterDetails", {
            ...formData,
            isSearchFilterActive: true,
          });
          store.dispatch("setFileListing", manipulatedList);
        }
        searchDialog.hide(true);
      })
      .fail((error) => {
        console.error("Szerver hiba:", error);
      })
      .always(() => {
        continuePolling = false;
      });
  };

  const customDateFormat = utils.getUserCustomizationValue(
    "DATE_FORMAT_TEXT",
    true
  );
  const dateFormat = utils.getFlatpickrDateFormat();
  const dateFormatText = utils.isBrowserLocaleDateFormat()
    ? dateFormat
        .replaceAll("Y", "yyyy")
        .replaceAll("m", "MM")
        .replaceAll("d", "dd")
    : customDateFormat || "mm/dd/yyyy";

  const searchDialog = new Modal({
    title: "Search",
    body: SearchTemplate({ dateFormatText }),
    uniqueId: "search-form",
    buttons: [
      {
        label: "cancel",
        close: true,
        classes: ["primary-button", "is-bordered", "mr-3"],
        onClick: () => {},
      },
      {
        label: "startSearch",
        close: false,
        classes: ["primary-button"],
        onClick: handleSearch,
      },
    ],
    minWidth: "520px",
    onBeforeHide: () => {
      const formData = utils.serializeInputs(searchDialog.root, false, true);
      let updatedSearchFilterDetails = store.searchFilterDetails;

      store.dispatch("setSearchFilterDetails", {
        ...updatedSearchFilterDetails,
        ...formData,
        hasOpened: true,
      });
    },
  });

  _$("#searchModalForm").on("submit", (e) => {
    e.preventDefault();
    handleSearch();
  });

  if (!store.searchFilterDetails.hasOpened) {
    const {
      searchDefaultType,
      searchDefaultModifiedBefore,
      searchDefaultModifiedAfter,
      searchDefaultSize,
    } = store.userInfo.userCustomizations;

    let updatedSearchFilterDetails = store.searchFilterDetails;

    const updateSearchFilterDetails = (data = {}) => {
      updatedSearchFilterDetails = {
        ...updatedSearchFilterDetails,
        ...data,
      };
    };

    const searchDefaultExactMatch = utils.getUserCustomizationValue(
      "searchDefaultExactMatch"
    );
    updateSearchFilterDetails({ exact: searchDefaultExactMatch });

    if (searchDefaultModifiedBefore) {
      updateSearchFilterDetails({
        date1: "true",
        date1_action: "before",
        date1_value: searchDefaultModifiedBefore.value,
      });
    }

    if (searchDefaultModifiedAfter) {
      updateSearchFilterDetails({
        date2: "true",
        date2_action: "after",
        date2_value: searchDefaultModifiedAfter.value,
      });
    }

    if (searchDefaultType) {
      updateSearchFilterDetails({
        type1: "true",
        type1_action: searchDefaultType.value === "dir" ? "folder" : "file",
      });
    }

    if (searchDefaultSize) {
      if (typeof searchDefaultSize.value === "string") {
        const firstChar = searchDefaultSize.value.charAt(0);
        if (firstChar === "<") {
          updateSearchFilterDetails({
            size2: "true",
            size2_action: "smaller than",
            size2_value: searchDefaultSize.value.substr(1),
          });
        } else if (firstChar === ">") {
          updateSearchFilterDetails({
            size1: "true",
            size1_action: "bigger than",
            size1_value: searchDefaultSize.value.substr(1),
          });
        }
      }
    }

    store.dispatch("setSearchFilterDetails", {
      ...updatedSearchFilterDetails,
      hasOpened: true,
    });
  }

  const searchFilterDetails = store.searchFilterDetails;

  const checkFilter = (checkboxId) => {
    const checkbox = _$(searchDialog.root).find(`#${checkboxId}`).el();
    if (checkbox) {
      checkbox.checked = true;
    }
  };

  const dateInputs = [
    {
      wrapId: "modified-1-wrap",
      checkboxId: "modifiedSearch1",
      options: { dateFormat, defaultDate: searchFilterDetails.date1_value },
    },
    {
      wrapId: "modified-2-wrap",
      checkboxId: "dateSearch2",
      options: { dateFormat, defaultDate: searchFilterDetails.date2_value },
    },
  ];

  dateInputs.forEach(({ wrapId, checkboxId, options }) => {
    const calendar = flatpickr(`#${wrapId}`, {
      ...options,
      wrap: true,
    });
    calendar.setDate(options.defaultDate);
    calendar.config.onChange.push((selectedDates) => {
      if (selectedDates.length) {
        checkFilter(checkboxId);
      }
    });
  });

  const modalBody = searchDialog.modal.body;
  const inputElementsSearchDialog = modalBody.querySelectorAll(
    "select,input:not([class*='date-input'])"
  );

  inputElementsSearchDialog.forEach((input) => {
    if (searchFilterDetails[input.name]) {
      if (input.type === "checkbox") {
        input.checked = true;
      }
      if (input.type === "radio") {
        if (input.value === searchFilterDetails[input.name]) {
          input.checked = true;
        }
      } else {
        input.value = searchFilterDetails[input.name];
      }
    }
  });

  [
    ["modified-1", "modifiedSearch1"],
    ["modified-2", "dateSearch2"],
    ["size-1", "sizeSearch1"],
    ["size-2", "sizeSearch2"],
  ].forEach(([inputId, checkboxId]) => {
    const input = _$(searchDialog.root).find(`#${inputId}`).el();
    input?.addEventListener("input", () => {
      if (input.value) {
        checkFilter(checkboxId);
      }
    });
  });

  modalBody
    .querySelector('select[name="type1_action"]')
    ?.addEventListener("change", () => {
      checkFilter("typeSearch1");
    });
};